export default __webpack_public_path__ + "1ed6e96b0cdc86bc929aad5e75fc8242.jpg";